import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

// This is a frequently-updated personal site, not an offline-first app —
// a cache-first service worker means visitors (and I, when deploying)
// see stale content until every open tab is closed. Unregister instead
// of register() so the browser always hits the network for fresh builds.
serviceWorkerRegistration.unregister();
